import { render, staticRenderFns } from "./PaymentInvestment.vue?vue&type=template&id=a0a3d10a&"
import script from "./PaymentInvestment.vue?vue&type=script&lang=js&"
export * from "./PaymentInvestment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports